import { render, staticRenderFns } from "./catalog.vue?vue&type=template&id=2e7a9da8&scoped=true&"
import script from "./catalog.vue?vue&type=script&lang=js&"
export * from "./catalog.vue?vue&type=script&lang=js&"
import style0 from "./catalog.vue?vue&type=style&index=0&id=2e7a9da8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7a9da8",
  null
  
)

export default component.exports